import AreaChip from "Components/Common/Chip/AreaChip";
import { TaskTemplate } from "Models/Tasks/TaskTemplate";
import * as React from "react";
import { connect } from "react-redux";
import { IApplicationState } from "Store/Store";
import { ITaskTemplateState } from "Store/TaskTemplates/TaskTemplateState";
import styles from "./TaskTemplateListDetailsBlock.scss";

interface IProps {
    taskTemplate: TaskTemplate;
    taskTemplateState: ITaskTemplateState;
}

interface IState {
    taskTemplate: TaskTemplate;
}

const mapStateToProps = (state: IApplicationState) => ({
    taskTemplateState: state.taskTemplateState
});

export class TaskTemplateListDetailsBlock extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
    }

    public render() {
        return (
            <div className={styles.taskTemplateListDetailsBlock}>
                {this.props.taskTemplate.area && <AreaChip className={styles.chip} area={this.props.taskTemplate.area} filteredArea={this.props.taskTemplateState.currentArrangeFilter && this.props.taskTemplateState.currentArrangeFilter.area} />}
            </div >
        );
    }
}

export default connect(mapStateToProps, null)(TaskTemplateListDetailsBlock);


// WEBPACK FOOTER //
// ./src/Components/Pages/TaskTemplateListOverview/TaskTemplateListView/TaskTemplateListCard/TaskTemplateListDetailsBlock/TaskTemplateListDetailsBlock.tsx